/*
 * @Author: wufan 
 * @Date: 2019-08-19 18:00:40 
 * @Last Modified by: wufan
 * @Last Modified time: 2019-09-03 19:38:38
 * 帮助中心-搜索框
 */


import React, { useEffect,useState}  from 'react';
import './SearchBar.less';
import { Input } from 'antd';
import AxiosTS from '../../core/axios';
import {
  withRouter
} from 'react-router-dom';

const { Search } = Input;

const SearchBar: React.FC = (props: any) => { 
  const searchKey = props.location.pathname.indexOf('/',5) !== -1 && props.location.pathname.indexOf('result') !== -1 ? props.location.pathname.slice(props.location.pathname.indexOf('/',5)+ 1) : "";
  
  const [keyWords,setKeyWords] = useState([]);//关键词列表
  const [query,setQuery] = useState(searchKey);

  useEffect(() => { 
    AxiosTS.postJSON("manage/anon/helpCenter/queryKeyWords", {})
      .then((res:any) => { 
        if (res.code === '200') { 
          setKeyWords(res.result)
        }
      })
  }, [])

  
  function changeRouter(value: string) { 
    if (value.trim().length === 0) { 
      return;
    }
    props.history.push({
      pathname: `/result/${query}`,
      params:{
        keyWord:value
      }
    })
  }

  return (
    <div className="search-bar">
      <div className="center">
        <div className="box">
          <Search
            placeholder="请输入关键词进行搜索"
            enterButton="搜索"
            size="large"
            style={{ width: "800px", height: '53px' }}
            onSearch={changeRouter}
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            type="search"
          />
        </div>
        <div className="key-words-list">
          {keyWords.map((item: string) => { 
              return <span className="key-word" onClick={() => {
                setQuery(item);
                props.history.push({
                  pathname: `/result/${item}`,
                  params:{
                    keyWord:item
                  }
                })
              }
              } key={item}>{item}</span>
            })}
          </div>
      </div>
    </div>
  )
}

export default withRouter(SearchBar);

